var SummaryIconComponent = new JS.Class(EditorComponent, {
  initialize: function(iconSelector) {
    this.iconField = $(iconSelector);
  },

  getSaveData: function() {
    return {
      SummaryIcon: {
        summary: '',
        icon: this.iconField.val(),
      },
    };
  },
});
